import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export function HODApprovalButton(
  sampleRequestID,
  hodApprovalButtonDisabled,
  handleOpenHODApprovalModal
) {
  return (
    <Grid item>
      <Button
        size="small"
        variant="contained"
        disabled={hodApprovalButtonDisabled}
        sx={{
          padding: "10px 20px",
          mr: "20px",
          fontSize: "14px",
          backgroundColor: "#c7ab79",
        }}
        onClick={handleOpenHODApprovalModal}
      >
        Approve Or Reject
      </Button>
    </Grid>
  );
}
